<template>
    <el-dialog
        :visible.sync="dialogFlag"
        width="20%"
        top="15%"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div slot="title" class="header-title">
           <span>修改手机号</span>
        </div>
        <div class="Content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <el-form-item  prop="phone">
                    <el-input v-model.number="ruleForm.phone" clearable maxlength="11"></el-input>
                </el-form-item>
            </el-form>
        </div>  
        <div slot="footer" class="dialog-footer">
          <el-button  @click="showHidePhoneNumberDialog(false)">取 消</el-button>
          <el-button class="determine" @click="confirm(ruleForm)">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
  export default {
    data() {
        var checkPhone = (rule, value, callback) => {
            const regExp = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (!value) {
            return callback(new Error('手机号不能为空'));
            }else if (!regExp.test(value)) {
                callback(new Error('请输入11位正确的手机号'))
            } else {
                callback();
            }
        }
        return {
            dialogFlag: false,
            ruleForm:{
                phone:''
            },  
            rules: {
            phone: [
                { validator: checkPhone, trigger: 'change' }
            ]
            }        
        };
    },
    props:{
      value:Boolean,
      studentId:String
    },
    watch:{
      value: function(){
          if(this.value){
            this.dialogFlag=this.value  
            this.getPhoneNumber()

          }
      },
    },
    methods:{
        showHidePhoneNumberDialog: function(flag){
            this.dialogFlag = flag
            this.$emit('cancel') 
        },
        getPhoneNumber:function(){  //获取手机号
            let params={id:this.studentId}
            this.$http.get("/examination/phone",{params}).then((res) => {
                if (res.data.success) {
                    this.ruleForm.phone=res.data.data.mobilePhone                 
                }
            })
        },
        confirm(){
            this.$refs["ruleForm"].validate((valid) => { //校验手机号
                if (valid) {
                    let params={
                        id:this.studentId,
                        mobilePhone:this.ruleForm.phone
                    }
                    this.$http.put(`/examination/phone`, params).then((res) => {
                        if (res.data.success) {
                            this.showHidePhoneNumberDialog(false)
                            this.$message.success('修改成功！');
                            this.$emit('saveCallBack') 
                        }else{
                            this.$message.error(`${res.data.msg}`);
                        }
                    })
                }
            });
        },
    }
}   
</script>
<style scoped>
.header-title{
    padding: 20px 0 0 0;
    font-size: 34px;
    font-weight:bold;
    text-align: center;
    
}
::v-deep  .el-dialog__body {
  padding: 20px 30px 0 30px;
  font-size: 16px;
}

::v-deep .el-dialog__footer{
    width: 100%;
    padding: 0;
    margin-top:50px;
    border-top: 2px solid #EDEDED;
    
}
.dialog-footer{
  width: 100%;
  display:flex;
  height: 120px;
}

.determine{
    color: #54B0FB;
}
.dialog-footer /deep/ .el-button{
  margin: 0;
    padding: 0;
    width: 50%;
    border-radius: 0;
    border: none;
    border-right: 2px solid #EDEDED;
    font-size: 16px;
}

</style>